import { gql } from '$lib/apollo';

export const EDIT_ACCOUNT = gql`
  mutation EditAccount($input: AccountEditInput!) {
    accountEdit(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      result {
        id
        name
        slug
        avatar {
          original {
            url
          }
        }
        email
        bio
        cover {
          original {
            url
          }
        }
        country
        timezone
        languages
      }
    }
  }
`;
